import { Stack, Typography } from '@mui/material'
import { Form, TextField } from '@edge/spark/feature-mui-rhf-inputs'
import { CheckboxButtonGroup } from 'react-hook-form-mui'

export const RegisterTitlesForm = () => {
    return (
        <Form>
            <Stack gap={4}>
                <Typography fontWeight={600}>Register Titles</Typography>

                <TextField name="dateReceived" label="Date Received" />

                <TextField name="state" label="State" />

                <CheckboxButtonGroup
                    label="Title Code"
                    name="titleCode"
                    options={[
                        {
                            id: '1',
                            label: 'Exempt',
                        },
                        {
                            id: '2',
                            label: 'Flood Damage',
                        },
                        {
                            id: '3',
                            label: 'Frame Damage',
                        },
                        {
                            id: '4',
                            label: 'Miles Over',
                        },
                        {
                            id: '5',
                            label: 'Salvage',
                        },
                        {
                            id: '6',
                            label: 'True Miles Unknown',
                        },
                    ]}
                />
            </Stack>
        </Form>
    )
}
